module.exports = __webpack_public_path__ + "img/new3-1.211cd4bb.jpg";